import { render, staticRenderFns } from "./TransactionsInventory.vue?vue&type=template&id=0cda0cde"
import script from "./TransactionsInventory.vue?vue&type=script&lang=js"
export * from "./TransactionsInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports